import classNames from 'classnames';
import React from 'react';
import { Badge } from '@/components/ui/badge';

import { ShiftLabelInfo } from '../types';

type Props = {
  shiftLabels: ShiftLabelInfo[];
};

const ShiftLabelsTags: React.FC<React.PropsWithChildren<Props>> = ({
  shiftLabels,
}) => (
  <>
    {shiftLabels.map((sl) => (
      <Badge
        key={sl.id}
        variant="light"
        className={classNames('rounded-sm', 'fw-bold', 'me-1')}>
        {sl.tagName}
      </Badge>
    ))}
  </>
);

export default ShiftLabelsTags;
